import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Button, TextField} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const [newStripeId, setNewStripeId] = React.useState('');
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(false);

  const clientPaymentPlan = props.clientPaymentPlan;
  const updateClientStripeId = props.updateClientStripeId;
  const setViewMode = props.setViewMode;

  React.useEffect(() => {
    if (clientPaymentPlan && clientPaymentPlan.stripeCustomerId != null) {
      setNewStripeId(clientPaymentPlan.stripeCustomerId );
    } else {
      setNewStripeId('');
    }
  }, [clientPaymentPlan]);


  React.useEffect(() => {
    setIsSaveDisabled(!newStripeId);
  }, [newStripeId]);

  const onSave = () => {
    setIsSaving(true);
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateClientStripeId(newStripeId, onSuccess);
  };

  return (
    <Stack
      direction={'column'}
      spacing={1}
      sx={{
        'display': 'flex',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.PaymentPlan.StripeIdTitle'
          />
        </Typography>
      </Box>
      <Box>
        <TextField
          value={newStripeId}
          onChange={(e) => setNewStripeId(e)}
          sx={{
            '& .MuiInputBase-input': {
              padding: '4px 2px',
            },
          }}
        />
      </Box>
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='generic.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          <Translate expression='generic.Save' />
        </Button>
      </Stack>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  updateClientStripeId: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
